<template>
  <div v-click-outside="externalClick">
    <div :id="'module' + moduleId" class="outerDiv">
      <div v-if="customViews" class="parent-tiles-div" id="control">
        <div class="tiles-arrow">
          <img
            src="../assets/sdt-icons/left-arrow.png"
            alt="previous"
            class="arrows"
            @click="Scrollbar"
            id="btnScrollLeft"
          />
        </div>
        <div id="scrollIt">
          <div class="sdt-tiles" id="tiles"></div>
        </div>
        <div class="tiles-arrow">
          <img
            src="../assets/sdt-icons/right-arrow.png"
            alt="previous"
            class="arrows"
            @click="Scrollbar"
            id="btnScrollRight"
          />
        </div>
      </div>

      <div id="'sh-icon_'+moduleId" class="sh-icon">
        <div id="boxModule"></div>
        <div class="buttons-div">
          <div>
            <div class="dropdown" v-if="downloadAs">
              <button class="dropbtn">
                Download Selected
                <img
                  src="../assets/grey-arrow.png"
                  class="download-selected-arrow"
                  width="8px"
                  height="4px"
                />
              </button>
              <div class="dropdown-content">
                <a
                  id="download-csv"
                  @click="() => getDownloadSelectedOption('csv')"
                  >As CSV</a
                >
                <a
                  id="download-pdf"
                  @click="() => getDownloadSelectedOption('pdf')"
                  >As PDF</a
                >
              </div>
            </div>
            <!-- <div style="background:white;height:28px;padding:4px;border: 1px solid #cbcbcb;overflow: hidden;">{{currentView}}</div>
                <img style="width:19px;" class="view-btn" title="List views" src="" @click="onViewsClick"/>
                <img id="sh-system-def-btn" title="Restore default view" class="sdt-m-i" src=""/>

                <img class="sdt-m-i" title="Save view" id="sh-save-btn" src=""/>
                <img class="sdt-m-i" title="Create view as" id="sdt-savas-btn" src=""/>
                <img class="sdt-m-i" title="Mark as default view" id="sh-def-btn" src=""/>
                <img class="sdt-m-i" title="Delete view" id="sh-del-btn" src=""/>
                <img class="sdt-m-i" title="Add view to tiles" id="sh-tile-btn" src=""/> -->
          </div>
          <div class="searchDiv">
            <input
              v-if="tableSearch"
              v-model="oldSearchValue"
              type="text"
              placeholder="Search here.."
              id="search-bar"
              class="tableSearchbar"
            />
            <button
              v-if="tableSearch"
              type="input"
              id="srch-btn"
              :style="colorFlag ? colorPassed : ''"
              v-bind:class="{
                normalBtnAlsharqi: alsharqiFlag,
                normalBtnQafila: qafilaFlag,
                normalBtn: searchBtnFlag,
                'default-search-button': defaultSearchBtnFlag,
              }"
            >
              Search
            </button>
          </div>
          <div class="rightDiv">
            <!-- <img id="filter" title="Filter" class="filter" src="" @click="onToggleFilter()"/> -->
            <img
              v-if="rowHeights"
              id="sh-dens-sm"
              title="Dense view"
              class="sh-dens-sm"
              src=""
            />
            <img
              v-if="rowHeights"
              id="sh-dens-md"
              title="Normal view"
              class="sh-dens-md"
              src=""
            />
            <img
              v-if="rowHeights"
              id="sh-dens-lg"
              title="Wide view"
              class="sh-dens-lg"
              src=""
            />
            <!-- ******** SAVE BUTTON (UNCOMMENT LATER) ********* -->
            <!-- <button v-if="customViews" class="saveViewBtn" id="sh-save-btn">Save Current View</button> -->
            <SMultipleSelect
              :checkbox="true"
              :avatar="false"
              v-model="selectedColumns"
              :label="'Column Settings'"
              :data="columns"
              optionLabel="name"
              v-on:selected-values="getSelectedColumns"
              style="width: 200px"
              :sortList="true"
              :groups="true"
            />
            <!-- <img width="140px" height="36px" id="sh-dt-settings" title="Column settings" v-on:click="onSettingsClick(moduleId)" src="../assets/sdt-icons/edit-columns.png"/> -->
          </div>
        </div>
        <div id="sh-views" class="sh-views"></div>
        <!-- <div id="table-heads-menu" class="table-heads-menu">
            <ul id="sh-setting-list" class="sh-setting-list"></ul>
            <div id="sv-btn" class="sv-btn">
                <input type="button" class="sh-btn sh-save-btn" :style="themeColor?btnColor:''" id="sdt-apply" value="Apply"/>
            </div>
        </div> -->
        <div id="sdt-filter" class="sdt-filter"></div>
      </div>
      <!-- <div v-if="!newDataFlag" style="color: red">Data not available.</div> -->
      <div id="sh-dt-dv" class="sh-dt-dv">
        <template>
          <div>
            <!-- <div>
              <table id="tb-head" class="tb-head">
                    </table>
            </div> -->
            <div
              id="sharkTableBody"
              class="sharkTableBody main-scroll-div"
              style="overflow-y: scroll; overflow-x: auto"
            >
              <table class="tb-body" id="tb-body" ></table>
              <!-- <table>99999999999999</table> -->
            </div>
          </div>
        </template>
      </div>
      <br />
      <div>
        <!-- <s-pagination
           v-model="currentPage"
          :page-count="this.totalPages"
          @input="pagination"
        /> -->
        <div v-if="parentData" class="pg-cont">
          <div class="pg-parent-s">
            <SSelect
              label="No of Rows"
              v-model="pageSize"
              :source="rowsOptions"
              resultsValue="name"
              resultsDisplay="name"
              :autocomplete="false"
              :disabled="false"
              :readonly="false"
              :border="false"
              :invertDropdown="invertDropdown"
              @selected="onNoOfRowsChange"
            />
          </div>
          <div style="display: flex; margin-left: 10px">
            <div class="pg-bg">
              <img
                v-on:click="onPrevClick()"
                class="sdt-pag"
                title="Previous"
                @mouseover="hoverLeft = true"
                @mouseleave="hoverLeft = false"
                :src="hoverLeft ? whiteLeftArrow : blackLeftArrow"
              />
            </div>
            <div class="pg-list">
              {{ pageStart }}-{{ pageEnd }}/{{ totalElements }}
            </div>
            <div class="pg-bg">
              <img
                v-on:click="onNextClick()"
                class="sdt-pag"
                title="Next"
                @mouseover="hoverRight = true"
                @mouseleave="hoverRight = false"
                :src="hoverRight ? whiteRightArrow : blackRightArrow"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- VIEW RELATED DIALOGS -->
    <SDialog
      v-show="openAddDialog"
      @close="closeModal"
      :title="dialogTitle"
      :persistent="true"
      :width="410"
    >
      <div class="dialog-body">
        <SInput
          label="Enter View Name"
          v-model="newViewName"
          :class="{ 'error-class': viewNameError == true }"
        />
        <br />
        <SSelect
          label="Select Privacy"
          v-model="viewPrivacy"
          :source="privacyOptions"
          resultsValue="name"
          resultsDisplay="name"
          :autocomplete="false"
          :disabled="false"
          :readonly="false"
          @selected="onSelectedPrivacy"
          :class="{ 'error-class': viewPrivacyError == true }"
        />
        <br /><br />

        <div class="mb-40">
          <button type="button" class="newViewSaveBtn" @click="onSaveView">
            {{ dialogButtonText }}
          </button>
        </div>
      </div>
    </SDialog>
  </div>
</template>

<script>
import { initializeDensityButtons_v2 } from "./util/density-v2";
import { initResisableTable_v2 } from "./util/resizable-grid";
import {
  generateTableUpdated_v2,
  removeTable_v2,
  resetColumnSettings,
  getGlobalTableHeads_v2,
  getGlobalSearchValue_v2,
  resetGlobalSearchValue_v2,
  getGlobalCurrentViewName_v2,
  resetGlobalVariables,
  getMessage_v2,
  getGlobalDensity_v2,
  getGlobalViews_v2,
  getGlobalSortField_v2,
  getGlobalSortDirection_v2,
  getRowId_v2,
  resetTilesAndViews,
  setGlobalTableHeads_v2,
  setGlobalStaticColumns,
  closePreviouslyOpenedDropdowns,
} from "./util/initialize-sdt";
import {
  createMenu_v2,
  createViews_v2,
  showTableHeadsMenu_v2,
  showViewsMenu_v2,
  setTileColor,
  getFilteredDataCount,
  initializeTableSearch,
} from "./util/column-settings";
import {
  toggleFilter_v2,
  loadViewFilters,
  getGlobalFiltersArray_v2,
  resetGlobalFiltersArray_v2,
} from "./util/custom-filter";
import { sdtV2Service } from "../services/sdtV2Service";
import SMultipleSelect from "../components/SMultipleSelect";
import moment from "moment";
// import SPagination from './SPagination.vue';
import SDialog from "../components/SDialog";
import SInput from "../components/SInput";
import SSelect from "../components/SSelect";

export default {
  name: "Sdt",

  props: {
    parentData: Array,
    parentDefaultSystemView: Object,
    parentSystemSettings: Object,
    dataDepart: Function,
    themeColor: {
      required: false,
      type: String,
    },
    filteredDataCount: {
      required: false,
    },
    rowHeights: Boolean,
    customViews: Boolean,
    tableSearch: Boolean,
    downloadAs: Boolean,
    actionsButton: Boolean,
    moreButton: Boolean,
    token: String,
    invertDropdown: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      viewNameError: false,
      viewPrivacyError: false,
      hoverLeft: false,
      hoverRight: false,
      whiteLeftArrow: require("../assets/sdt-icons/prev-arrow.png"),
      blackLeftArrow: require("../assets/sdt-icons/left-arrow.png"),
      whiteRightArrow: require("../assets/sdt-icons/next-arrow.png"),
      blackRightArrow: require("../assets/sdt-icons/right-arrow.png"),
      counter: 0,
      prevLength: 0,
      isLoadingPage: false,
      isLoading: false,
      oldSearchValue: "",
      pageData: "",
      pageSize: 100,
      newDataFlag: false,
      tableHeads: "", //description of fields
      density: "",
      height: "",
      sortField: "",
      sortDirection: "",
      views: "", //list
      moduleId: "ShipmentTestPage", //pageId
      selectionColumn: "",
      selectType: "",
      hoverButtons: "",
      totalElements: 0,
      offset: 0,
      totalPages: 0,
      defaultSystemView: "",
      loadedView: "",
      systemSettings: "",
      newData: "",
      result: "",
      data: "",
      searchQuery: "",
      limit: 0,
      status: "",
      message: "",
      currentDefaultView: "",
      alsharqiFlag: false,
      qafilaFlag: false,
      delCheck: null,
      searchBtnFlag: false,
      defaultSearchBtnFlag: true,
      currentView: "",
      colorFlag: false,
      pageEnd: 100,
      updatedViewName: "",
      staticColumns: [],
      moreOptions: [],
      selectedColumns: [],
      columns: [],
      actionsOptions: [],
      pageStart: 1,
      currentPage: 1,
      checkedRows: [],
      currentCheckedRow: null,
      columnIcons: [],
      pillConfig: [],
      openAddDialog: false,
      newViewName: "",
      user: "",
      newViewFlag: true,
      dialogButtonText: "Add",
      dialogTitle: "New View Tile",
      oldViewName: "",
      privacyOptions: [
        {
          name: "Visible To You (Private)",
          value: "Private",
          itemIcon: "private",
        },
        {
          name: "Visible to Everyone (Public)",
          value: "Public",
          itemIcon: "public",
        },
      ],
      viewPrivacy: "",
      uppercaseColumns: [],
      dateFormat: "",
      rowsOptions: [
        { name: "25", value: "25" },
        { name: "50", value: "50" },
        { name: "100", value: "100" },
      ],
    };
  },

  computed: {
    colorPassed() {
      return {
        background: this.themeColor
          ? this.themeColor
          : "rgb(67, 123, 235)" /* theme color coming from prop */,
        border: "none",
        "margin-left": "10px",
        height: "30px",
        color: "white",
      };
    },

    btnColor() {
      return this.getThemeColor();
    },

    count: function () {
      return this.filteredDataCount;
    },
  },

  components: {
    SDialog,
    SMultipleSelect,
    // SPagination,
    SInput,
    SSelect,
  },

  methods: {
    Scrollbar() {
      let control = document.querySelector("#control");

      control.addEventListener("click", function (e) {
        // get the scrollIt
        let div = document.getElementById("scrollIt");
        // get the target
        let target = e.target;
        // handle each button's click
        switch (target.id) {
          case "btnScrollLeft":
            div.scrollLeft -= 10;
            break;

          case "btnScrollRight":
            div.scrollLeft += 10;
            break;
        }
      });
    },

    getThemeColor() {
      if (this.themeColor === "alsharqi") {
        return { background: "#d03232" };
      } else if (this.themeColor === "qafila") {
        return { background: "rgb(67, 123, 235)" };
      } else if (
        this.themeColor !== "qafila" &&
        this.themeColor !== "alsharqi" &&
        this.themeColor
      ) {
        return { background: this.themeColor };
      } else {
        return { background: "#437beb" };
      }
    },

    fireResultEvent(status, message) {
      // window.console.log("fire result event", message);

      if (status === 2) {
        if (message.includes("cannot") || message.includes("Cannot")) {
          this.$toast.warning(message, {
            timeOut: 3000,
          });
        } else {
          this.$toast.success(message, {
            timeOut: 3000,
          });
        }
      }

      let data = {
        searchQuery: this.oldSearchValue,
        sortField: this.sortField,
        sortDirection: this.sortDirection,
        offset: this.offset,
        limit: this.pageSize,
      };

      this.result = {
        status: status,
        message: message,
        data: data,
      };

      // converting dates according to criteria API format before sending to BE
      let cols = this.result.message;
      if (!(status == 9 || status == 10)) {
        for (let index = 0; index < cols.length; index++) {
          if (
            cols[index].fieldType === "date" &&
            cols[index].comparisonType !== "Like"
          ) {
            if (cols[index].filterValue.includes(".")) {
              //this if is being used for loading views containing date filters properly
              if (cols[index].filterValue) {
                cols[index].filterValue = moment(
                  cols[index].filterValue,
                  "YYYY.MM.DD"
                ).format("YYYY-MM-DD hh:mm:ss");
              }
              if (cols[index].secondValue) {
                cols[index].secondValue = moment(
                  cols[index].secondValue,
                  "YYYY.MM.DD"
                ).format("YYYY-MM-DD hh:mm:ss");
              }
            }
          }
        }
      }

      // window.console.log("checking result data", this.result);
      this.dataDepart(this.result); //event emiiting to parent side
    },

    setDateFormat(data) {
      let dateCols = [];
      let allColumns = this.tableHeads;
      allColumns.push(this.staticColumns);

      allColumns.forEach((col) => {
        if (col.fieldType == "date") {
          dateCols.push(col.fieldName);
        }
      });

      for (let i = 0; i < dateCols.length; i++) {
        for (let j = 0; j < data.length; j++) {
          if(data[j][dateCols[i]]!== null){
            if (
              this.dateFormat.includes("H") ||
              this.dateFormat.includes("h") ||
              this.dateFormat.includes("s") ||
              this.dateFormat.includes("S") ||
              this.dateFormat.includes("m") ||
              this.dateFormat.includes("A") ||
              this.dateFormat.includes("a")
              
            ) { 
              if(data[j][dateCols[i]].includes(".") &&
              data[j][dateCols[i]].includes("T") &&
              data[j][dateCols[i]].includes("-")){
              if(data[j][dateCols[i]].includes("+") )
              {data[j][dateCols[i]]=data[j][dateCols[i]].slice(0, data[j][dateCols[i]].indexOf("+"));}
              data[j][dateCols[i]] = moment(data[j][dateCols[i]]).format(this.dateFormat);
              data[j][dateCols[i]] = data[j][dateCols[i]].replace(" ", " \n ");
              
              }
            } 
            else if (
              data[j][dateCols[i]].includes(".") &&
              data[j][dateCols[i]].includes("T") &&
              data[j][dateCols[i]].includes("-")
            ) {
              data[j][dateCols[i]] = moment(
                data[j][dateCols[i]],
                "YYYY-MM-DD"
              ).format(this.dateFormat);
            } else {
              data[j][dateCols[i]] = moment(
                data[j][dateCols[i]],
                "YYYY.MM.DD"
              ).format(this.dateFormat);
            } 
          }
        }
      }
    },

    externalClick(evt) {
      closePreviouslyOpenedDropdowns("outsideClick");
    },

    onViewsClick() {
      showViewsMenu_v2(this.moduleId);
    },

    onToggleFilter() {
      toggleFilter_v2(this.moduleId);
    },

    onChange(event) {
      this.pageSize = event.target.value;
      this.offset = 0;
      this.totalPages = 0;
      this.fireResultEvent(1, getGlobalTableHeads_v2());
    },

    mapValues() {
      this.loadedView = this.defaultSystemView;
      this.moduleId = this.loadedView.defaultTable.pageName;
      this.tableHeads = this.loadedView.defaultTable.columns;
      this.density = this.loadedView.defaultTable.density;
      this.sortField = this.loadedView.defaultTable.sortField;
      this.sortDirection = this.loadedView.defaultTable.sortDirection;
      this.views = this.loadedView.viewNames;
      this.currentView = this.loadedView.defaultTable.viewName;
      this.pageSize = this.loadedView.defaultTable.pageSize;
    },

    mapSystemSettings() {
      this.oldSearchValue = this.systemSettings.searchValue;
      this.height = this.systemSettings.height;
      this.hoverButtons = this.systemSettings.buttons;
      this.selectionColumn = this.systemSettings.selectionColumn;
      this.selectType = this.systemSettings.selectType;
      this.staticColumns = this.systemSettings.staticColumns;
      this.moreOptions = this.systemSettings.moreOptions;
      this.actionsOptions = this.systemSettings.actionsOptions;
      this.columnIcons = this.systemSettings.columnIcons;
      this.pillConfig = this.systemSettings.pillConfig;
      this.user = this.systemSettings.user;
      this.uppercaseColumns = this.systemSettings.uppercaseColumns;
      this.dateFormat = this.systemSettings.dateFormat;
    },

    //Calling Js Files Functions From here
    initializeTable() {
      if (this.newData.length == 0) {
        this.newData = null;
      }
      // window.console.log(this.newData);
      generateTableUpdated_v2(
        this.uppercaseColumns,
        this.user,
        this.pillConfig,
        this.columnIcons,
        this.actionsOptions,
        this.moreOptions,
        this.staticColumns,
        this.hoverButtons,
        this.selectType,
        this.selectionColumn,
        this.moduleId,
        this.tableHeads,
        this.newData,
        this.density,
        this.height,
        this.sortField,
        this.sortDirection,
        this.views,
        this.currentView
      );
      // createMenu_v2(this.tableHeads, this.moduleId, this.newData);
      if (this.customViews) {
        createViews_v2(this.moduleId, this.views, this.currentView);
      }
      if (this.tableSearch) {
        initializeTableSearch(this.moduleId);
      }
      if (!this.newData) {
        this.newDataFlag = false;
      }
    },

    //Pagination and Page per Item
    onPrevClick() {
      let tableHeads = getGlobalTableHeads_v2();
      let filterCheckFlag = false;
      if (this.offset > 0) {
        this.offset--;

        // checking if filtered call should execute or load call
        for (let index = 0; index < tableHeads.length; index++) {
          if (
            (tableHeads[index].filterFlag === true &&
              tableHeads[index].filterValue) ||
            tableHeads[index].secondValue
          ) {
            filterCheckFlag = true;
          }
        }

        if (filterCheckFlag) {
          this.fireResultEvent(4, getGlobalTableHeads_v2());
          filterCheckFlag = false;
        } else {
          this.fireResultEvent(1, getGlobalTableHeads_v2());
        }
      }
    },

    onNextClick() {
      let tableHeads = getGlobalTableHeads_v2();
      let filterCheckFlag = false;
      if (this.totalPages > 1 && this.pageEnd < this.totalElements) {
        this.offset++;

        // checking if filtered call should execute or load call
        for (let index = 0; index < tableHeads.length; index++) {
          if (
            (tableHeads[index].filterFlag === true &&
              tableHeads[index].filterValue) ||
            tableHeads[index].secondValue
          ) {
            filterCheckFlag = true;
          }
        }

        if (filterCheckFlag) {
          this.fireResultEvent(4, getGlobalTableHeads_v2());
          filterCheckFlag = false;
        } else {
          this.fireResultEvent(1, getGlobalTableHeads_v2());
        }
      }
    },

    onNoOfRowsChange(event) {
      this.pageSize = event.value;
      this.offset = 0;
      this.totalPages = 0;

      // setting height of table
      if (this.pageSize == 50) {
        this.height = "750px";
      } else if (this.pageSize == 100) {
        this.height = "950px";
      } else {
        this.height = "550px";
      }

      // checking if filtered call should execute or load call
      let tableHeads = getGlobalTableHeads_v2();
      let filterCheckFlag = false;
      for (let index = 0; index < tableHeads.length; index++) {
        if (
          (tableHeads[index].filterFlag === true &&
            tableHeads[index].filterValue) ||
          tableHeads[index].secondValue
        ) {
          filterCheckFlag = true;
        }
      }

      if (filterCheckFlag) {
        this.fireResultEvent(4, getGlobalTableHeads_v2());
        filterCheckFlag = false;
      } else {
        this.fireResultEvent(1, getGlobalTableHeads_v2());
      }
    },

    generatePageData() {
      this.pageStart = this.pageSize * this.offset + 1;
      this.pageEnd = this.pageStart + +this.pageSize - 1;
      // this.pageData = this.pageStart+"-"+this.pageEnd+"/"+this.totalElements;
    },

    // pagination(val){
    //     // console.log('pagination function',val);
    //     let filterCheckFlag = false;
    //     let tableHeads = getGlobalTableHeads_v2();

    //     if (val < 0) {
    //         this.currentPage = 1;
    //         this.offset = this.currentPage;

    //         // checking if filtered call should execute or load call
    //         if(tableHeads!=null){
    //             for (let index = 0; index < tableHeads.length; index++) {
    //                 if(tableHeads[index].filterFlag === true && tableHeads[index].filterValue || tableHeads[index].secondValue){
    //                     filterCheckFlag = true;
    //                 }
    //             }

    //             if(filterCheckFlag){
    //                 this.fireResultEvent(4,  getGlobalTableHeads_v2());
    //                 filterCheckFlag = false;
    //             }
    //             else{
    //                this.fireResultEvent(1,  getGlobalTableHeads_v2());
    //             }
    //         }
    //         return;
    //     }

    //     this.currentPage = val;
    //     this.offset = this.currentPage;
    //     // checking if filtered call should execute or load call
    //     if(tableHeads!=null){
    //         for (let index = 0; index < tableHeads.length; index++) {
    //             if(tableHeads[index].filterFlag === true && tableHeads[index].filterValue || tableHeads[index].secondValue){
    //                 filterCheckFlag = true;
    //             }
    //         }

    //         if(filterCheckFlag){
    //             this.fireResultEvent(4,  getGlobalTableHeads_v2());
    //             filterCheckFlag = false;
    //         }
    //         else{
    //            this.fireResultEvent(1,  getGlobalTableHeads_v2());
    //         }
    //     }
    // },

    //Events
    dataLoadEvent(eventData) {
      this.newData = eventData.data;

      // converting date data into passed date format
      this.setDateFormat(this.newData);

      this.totalElements = eventData.totalElements;
      this.totalPages = eventData.totalPages;
      this.currentPage = eventData.pageNumber == 0 ? 1 : eventData.pageNumber;
      this.generatePageData();
      removeTable_v2(this.moduleId);
      // resetColumnSettings();
      if (this.rowHeights) {
        initializeDensityButtons_v2(
          this.moduleId,
          this.tableHeads,
          this.newData
        );
      }
      // createMenu_v2(this.tableHeads, this.moduleId, this.newData);

      // handling conditional hover buttons
      if (
        (JSON.stringify(this.hoverButtons) ===
          JSON.stringify(this.parentSystemSettings.buttons)) ==
        false
      ) {
        this.mapSystemSettings();
        this.mapValues();

        // this.initializeTable();
        if (this.newData.length == 0) {
          this.newData = null;
        }
        if (this.rowHeights) {
          initializeDensityButtons_v2(
            this.moduleId,
            this.tableHeads,
            this.newData
          );
        }
        generateTableUpdated_v2(
          this.uppercaseColumns,
          this.user,
          this.pillConfig,
          this.columnIcons,
          this.actionsOptions,
          this.moreOptions,
          this.staticColumns,
          this.hoverButtons,
          this.selectType,
          this.selectionColumn,
          this.moduleId,
          this.tableHeads,
          this.newData,
          this.density,
          this.height,
          this.sortField,
          this.sortDirection,
          this.views,
          this.currentView
        );
        // initResisableTable_v2(this.moduleId);
        if (!this.newData) {
          this.newDataFlag = false;
        }

        resetTilesAndViews();
        createViews_v2(this.moduleId, this.views, this.currentView);
      } else {
        generateTableUpdated_v2(
          this.uppercaseColumns,
          this.user,
          this.pillConfig,
          this.columnIcons,
          this.actionsOptions,
          this.moreOptions,
          this.staticColumns,
          this.hoverButtons,
          this.selectType,
          this.selectionColumn,
          this.moduleId,
          this.tableHeads,
          this.newData,
          this.density,
          this.height,
          this.sortField,
          this.sortDirection,
          this.views,
          this.currentView
        );
      }
    },

    onSearchEvent() {
      this.oldSearchValue = getGlobalSearchValue_v2();
      this.fireResultEvent(1, getGlobalTableHeads_v2());
    },

    onSort() {
      this.sortField = getGlobalSortField_v2();
      this.sortDirection = getGlobalSortDirection_v2();

      // checking if filtered call should execute or load call
      let tableHeads = getGlobalTableHeads_v2();
      let filterCheckFlag = false;
      for (let index = 0; index < tableHeads.length; index++) {
        if (
          (tableHeads[index].filterFlag === true &&
            tableHeads[index].filterValue) ||
          tableHeads[index].secondValue
        ) {
          filterCheckFlag = true;
        }
      }

      if (filterCheckFlag) {
        this.fireResultEvent(4, getGlobalTableHeads_v2());
        filterCheckFlag = false;
      } else {
        this.fireResultEvent(1, getGlobalTableHeads_v2());
      }
    },

    onFilterEvent() {
      var changedTableHeads = getGlobalFiltersArray_v2();
      var message = getMessage_v2();

      // sending fieldnames without appending globalid
      // for (let index = 0; index < changedTableHeads.length; index++) {
      //     if(changedTableHeads[index].fieldName.includes('#')){
      //         let name = changedTableHeads[index].fieldName;
      //         name = name.split('#');
      //         name = name[0];
      //         changedTableHeads[index].fieldName = name;
      //     }
      // }
      this.fireResultEvent(4, changedTableHeads);
    },

    onSelectChange() {
      // setting offset to zero so every view's pagination starts from first page
      this.offset = 0;
      this.updatedViewName = getGlobalCurrentViewName_v2();
      if (this.updatedViewName == "SYSTEM VIEW") {
        this.onSystemDefaultViewClick();
      } else {
        sdtV2Service
          .getViewByName(this.moduleId, this.updatedViewName)
          .then((response) => {
            resetGlobalVariables();

            this.defaultSystemView = response.data;
            this.defaultSystemView.viewNames.push(
              {
                name: "Default View",
                tileFlag: true,
                position: 1,
                privacy: "private",
              },
              {
                name: "Add A View Tile",
                tileFlag: true,
                position: 0,
                privacy: "private",
              }
            );
            this.mapValues();
            this.initializeTable();

            // load filtered views if any
            let columns = this.defaultSystemView.defaultTable.columns;
            let flag = false;
            for (let index = 0; index < columns.length; index++) {
              if (columns[index].filterValue || columns[index].secondValue) {
                flag = true;
              }
            }
            if (flag) {
              loadViewFilters(this.defaultSystemView);
            } else {
              this.fireResultEvent(1, getGlobalTableHeads_v2());
            }
          })
          .catch((error) => {
            throw error;
          });
      }
    },

    onSaveClick() {
      var message = getMessage_v2();

      if (message === 2) {
        this.fireResultEvent(5, "");
        return;
      }

      this.loadedView.defaultTable.density = getGlobalDensity_v2();
      this.loadedView.defaultTable.columns = getGlobalTableHeads_v2();
      this.loadedView.defaultTable.viewNames = getGlobalViews_v2();
      this.loadedView.defaultTable.pageSize = this.pageSize;
      this.loadedView.defaultTable.sortField = getGlobalSortField_v2();
      this.loadedView.defaultTable.sortDirection = getGlobalSortDirection_v2();

      if (message === 1) {
        if (this.currentView != "Default View") {
          this.saveView(this.loadedView, false);
        } else {
          this.fireResultEvent(2, "Default View cannot be updated.");
        }
      }
    },

    onDelButton() {
      var updatedViewName = getGlobalCurrentViewName_v2();
      if (updatedViewName == "Default View") {
        this.fireResultEvent(2, "Default View cannot be deleted.");
      } else {
        sdtV2Service
          .removeView(this.moduleId, updatedViewName)
          .then((response) => {
            this.delCheck = response.data.description;

            // remove/delete from list only when it is not a default view
            if (!this.delCheck.includes("Cannot")) {
              // for auto update of views list
              if (this.currentDefaultView != this.currentView) {
                for (let index = 0; index < this.views.length; index++) {
                  if (this.views[index].name == this.currentView) {
                    this.views.splice(index, 1);
                  }
                }
                showViewsMenu_v2(this.moduleId);
                resetGlobalVariables();
                this.refresh();
              }
            }

            this.fireResultEvent(2, response.data.description);
            this.getDefaultView();
          })
          .catch((error) => {
            throw error;
          });
      }
    },

    getDefaultView() {
      sdtV2Service
        .getViews(this.moduleId)
        .then((response) => {
          resetGlobalVariables();
          this.loadedView = response;
          this.mapValues();
          this.initializeTable();
          this.fireResultEvent(1, getGlobalTableHeads_v2());
        })
        .catch((error) => {
          throw error;
        });
    },

    onSystemDefaultViewClick() {
      let viewNames = this.defaultSystemView.viewNames;
      let name = getGlobalCurrentViewName_v2();

      resetGlobalVariables();
      this.defaultSystemView.defaultTable.density =
        this.parentDefaultSystemView.defaultTable.density;
      this.parentDefaultSystemView.defaultTable.columns.map((col, colIndex) => {
        let keys = Object.keys(col);
        keys.map((key) => {
          this.defaultSystemView.defaultTable.columns[colIndex][key] =
            this.parentDefaultSystemView.defaultTable.columns[colIndex][key];
        });
      });
      this.defaultSystemView.viewNames = viewNames;
      this.defaultSystemView.defaultTable.pageSize =
        this.parentDefaultSystemView.defaultTable.pageSize;
      this.defaultSystemView.defaultTable.sortField =
        this.parentDefaultSystemView.defaultTable.sortField;
      this.defaultSystemView.defaultTable.sortDirection =
        this.parentDefaultSystemView.defaultTable.sortDirection;
      this.defaultSystemView.defaultTable.viewName = name;
      this.mapValues();
      if (this.newData.length == 0) {
        this.newData = null;
      }
      this.initializeTable();
      this.fireResultEvent(1, getGlobalTableHeads_v2());
    },

    saveView(updatedView, updateViewListFlag) {
      for (let i = 0; i < updatedView.viewNames.length; i++) {
        if (
          updatedView.viewNames[i].name == "Default View" ||
          updatedView.viewNames[i].name == "Add A View Tile"
        ) {
          updatedView.viewNames.splice(i, 1);
          i--;
        }
      }

      // removing previous relative date filters for new view
      if (updateViewListFlag) {
        let cols = updatedView.defaultTable.columns;
        for (let i = 0; i < cols.length; i++) {
          if (cols[i].compTypeDate) {
            cols[i].compTypeDate = null;
          }
          if (cols[i].thirdValue) {
            cols[i].thirdValue = null;
          }
        }
      }

      // checking for multiple filter values against one column
      let filters = getGlobalFiltersArray_v2();
      let columns = updatedView.defaultTable.columns;

      // clearing up previous filters if any
      for (let m = 0; m < columns.length; m++) {
        columns[m].filters = [];
      }

      for (let n = 0; n < filters.length; n++) {
        const filter = filters[n];
        let found = false;
        for (let i = 0; i < columns.length; i++) {
          const currentColumn = columns[i];
          if (currentColumn.fieldName === filter.fieldName) {
            if (currentColumn.comparisonType === filter.comparisonType) {
              currentColumn.filters.push(
                this.generateFilterObject(
                  filter.fieldName,
                  filter.comparisonType,
                  filter.filterValue
                )
              );
              found = true;
              break;
            }
          }
        }
        if (!found) {
          for (let i = 0; i < columns.length; i++) {
            const currentColumn = columns[i];
            if (currentColumn.fieldName === filter.fieldName) {
              currentColumn.filters.push(
                this.generateFilterObject(
                  filter.fieldName,
                  filter.comparisonType,
                  filter.filterValue
                )
              );
            }
          }
        }
      }

      updatedView.defaultTable.columns = columns;
      sdtV2Service
        .setViews(updatedView)
        .then((response) => {
          this.fireResultEvent(2, response.data.description);
          if (updateViewListFlag) {
            this.currentView = updatedView.defaultTable.viewName;
            this.views.push({
              name: "Add A View Tile",
              tileFlag: true,
              position: 0,
              privacy: "private",
            });

            this.views.push({
              name: "Default View",
              tileFlag: true,
              position: 1,
              privacy: "private",
            });

            this.views.push({
              name: this.currentView,
              tileFlag: true,
              position: window.globalViews_v2.length,
              privacy: this.viewPrivacy,
            });
            resetTilesAndViews();
            resetGlobalVariables();
            this.refresh();
          } else {
            //add Default View tile back and also in views list
            this.views.push({
              name: "Add A View Tile",
              tileFlag: true,
              position: 0,
              privacy: "private",
            });

            this.views.push({
              name: "Default View",
              tileFlag: true,
              position: 1,
              privacy: "private",
            });
          }
        })
        .catch((error) => {
          if (error) {
            this.$toast.error("View already exists!", {
              timeOut: 3000,
            });
          }
          throw error;
        });
    },

    generateFilterObject(field, operator, value) {
      let obj = {
        fieldName: field,
        operator: operator,
        value: value,
      };
      return obj;
    },

    saveAsEventFromFeAgent(event) {
      let viewName = event.detail;
      this.loadedView.defaultTable.viewName = viewName;
      this.loadedView.defaultTable.tileFlag = true;
      this.loadedView.defaultTable.position =
        window.globalViews_v2.length == 2 ? 2 : window.globalViews_v2.length;
      this.loadedView.defaultTable.privacy = event.privacy;
      this.saveView(this.loadedView, true);
    },

    onDefButton() {
      var updatedViewName = getGlobalCurrentViewName_v2();
      window.defaultView = updatedViewName;
      if (this.currentView == "Default View") {
        this.fireResultEvent(2, "Default View cannot be made default.");
      } else {
        sdtV2Service
          .setDefaultView(this.moduleId, updatedViewName)
          .then((response) => {
            let msg = response.data.description;
            this.fireResultEvent(2, msg);
            resetTilesAndViews();
            this.refresh();
          })
          .catch((error) => {
            throw error;
          });
      }
      this.currentDefaultView = updatedViewName;
    },

    // view detail hover button
    onclickView() {
      var id = getRowId_v2();
      this.fireResultEvent(6, id);
    },

    onclickDelete() {
      var id = getRowId_v2();
      this.fireResultEvent(7, id);
    },

    onclickEdit() {
      var id = getRowId_v2();
      this.fireResultEvent(8, id);
    },

    onClickRadio() {
      var id = getRowId_v2();
      this.fireResultEvent(9, id);
    },

    onClickCheckbox() {
      this.currentCheckedRow = getRowId_v2();
      let found = false;

      for (let i = 0; i < this.checkedRows.length; i++) {
        if (this.currentCheckedRow.id == this.checkedRows[i].id) {
          this.checkedRows.splice(i, 1);
          found = true;
          break;
        }
      }

      if (!found) {
        this.checkedRows.push(this.currentCheckedRow);
      }
      this.fireResultEvent(10, this.currentCheckedRow);
    },

    onClickCheckboxHead(allRows) {
      this.checkedRows = allRows.detail;
      this.fireResultEvent(10, allRows.detail);
    },

    onProcessBtnClick() {
      var id = getRowId_v2();
      this.fireResultEvent(11, id);
    },

    onTagBtnClick() {
      var id = getRowId_v2();
      this.fireResultEvent(12, id);
    },

    onMoreOptionClick(e) {
      this.$emit("clicked-option", e.detail);
    },

    refresh() {
      sdtV2Service
        .getViews(this.moduleId)
        .then((response) => {
          var viewData = response;

          if (response.data.responseIdentifier != "2") {
            this.defaultSystemView = viewData.data;
            this.defaultSystemView.viewNames.push(
              {
                name: "Add A View Tile",
                tileFlag: true,
                position: 0,
              },
              {
                name: "Default View",
                tileFlag: true,
                position: 1,
              }
            );
          }
          this.mapValues();
          this.initializeTable();
          this.fireResultEvent(1, getGlobalTableHeads_v2());
        })
        .catch((error) => {
          throw error;
        });
    },

    removeDuplicateColumns(columns) {
      for (let i = 0; i < columns.length; i++) {
        if (columns[i].length > 1) {
          for (let j = 0; j < columns[i].length; j++) {
            const col = columns[i][j];
            if (col.fieldName != "actions" && col.fieldName != "more") {
              columns.push(col);
            }
          }
          columns.splice(i, 1);
        }
      }
      return columns;
    },

    removeStaticColumnsFromMultiSelectArray(values) {
      for (let i = 0; i < values.length; i++) {
        const col = values[i];

        for (let j = 0; j < this.staticColumns.length; j++) {
          const staticCol = this.staticColumns[j];

          if (col.name == staticCol.labelName) {
            values.splice(i, 1);
            break;
          }
        }
      }

      return values;
    },

    addStaticColumnsinMultiSelectArray(values) {
      for (let j = 0; j < this.staticColumns.length; j++) {
        const staticCol = this.staticColumns[j];

        values.push({ name: staticCol.labelName });
      }

      return values;
    },

    getSelectedColumns(value) {
      this.selectedColumns = value;
      let defaultCols = this.defaultSystemView.defaultTable.columns;
      defaultCols = this.removeDuplicateColumns(defaultCols);
      let diff = value.length - this.prevLength;
      this.counter++;

      if (this.counter > 1) {
        // if column has been added
        if (value.length >= this.prevLength) {
          this.prevLength = value.length;

          if (diff > 1) {
            let newCols = value;
            for (var defaultCol of defaultCols) {
              for (var newCol of newCols) {
                if (newCol.name == defaultCol.labelName) {
                  defaultCol.checked = !defaultCol.checked;
                  break;
                }
              }
            }
          } else {
            let newCol = value[value.length - 1];
            let changed = false;
            defaultCols.forEach((col) => {
              if (!changed) {
                for (let i = 0; i < this.selectedColumns.length; i++) {
                  if (newCol.name == col.labelName) {
                    col.checked = !col.checked;
                    changed = true;
                    break;
                  }
                }
              }
            });
          }
        }
        // if column has been removed
        else {
          this.prevLength = value.length;
          // removing static cols so it doesnt go in infinte loop while matching with normal columns
          value = this.removeStaticColumnsFromMultiSelectArray(value);
          var tempDefCols = JSON.parse(JSON.stringify(defaultCols));
          let flag = false;

          for (let i = 0; i < value.length; ) {
            for (let j = 0; j < tempDefCols.length; j++) {
              if (!flag) {
                if (
                  tempDefCols[j].labelName == value[i].name ||
                  tempDefCols[j].labelName == ""
                ) {
                  tempDefCols.splice(j, 1);
                  flag = true;
                }
              } else {
                flag = false;
                i++;
                break;
              }
            }
          }

          // adding back static column in multi-select value array
          value = this.addStaticColumnsinMultiSelectArray(value);

          // setting checked flag to false of removed normal column
          for (let i = 0; i < defaultCols.length; i++) {
            for (let j = 0; j < tempDefCols.length; j++) {
              if (
                defaultCols[i].labelName == tempDefCols[j].labelName &&
                defaultCols[i].labelName != ""
              ) {
                defaultCols[i].checked = false;
              }
            }
          }

          // setting checked flag to false of removed static column
          // for(let i=0; i<this.staticColumns.length; i++){
          //     if(this.staticColumns[i].fieldName!='actions'&&this.staticColumns[i].fieldName!='more'){
          //         for(let j=0;j<tempDefCols.length;j++){
          //             if(this.staticColumns[i].labelName == tempDefCols[j].labelName){
          //                 this.staticColumns[i].checked = false;
          //             }
          //         }
          //     }
          // }
        }

        this.tableHeads = defaultCols;
        setGlobalTableHeads_v2(this.tableHeads);
        // console.log(this.staticColumns, 'static cols')
        setGlobalStaticColumns(this.staticColumns);
        this.fireResultEvent(1, getGlobalTableHeads_v2());
      }
    },

    setColumns() {
      var cols = this.defaultSystemView.defaultTable.columns;
      let normal = [];
      let staticCol = [];

      for (let i = 0; i < this.staticColumns.length; i++) {
        const element = this.staticColumns[i];

        if (element.fieldName != "actions" && element.fieldName != "more") {
          // to show pre-selected
          if (element.checked) {
            this.selectedColumns.push({ name: element.labelName });
          }
          staticCol.push({ name: element.labelName, disabled: true });
        }
      }

      cols.forEach((col) => {
        // to show pre-selected
        if (col.checked) {
          this.selectedColumns.push({ name: col.labelName });
        }

        // to show all columns in list
        normal.push({ name: col.labelName });
      });

      this.columns = [
        { name: "Normal", list: normal },
        { name: "Static", list: staticCol },
      ];
    },

    getDownloadSelectedOption(opt) {
      const uniq = new Set(this.checkedRows.map((e) => JSON.stringify(e)));
      const res = Array.from(uniq).map((e) => JSON.parse(e));
      this.checkedRows = res;

      let obj = {
        rows: res,
        option: opt,
      };

      this.$emit("download-as-option", obj);
    },

    addNewView() {
      this.newViewFlag = true;
      this.openAddDialog = true;
    },

    closeModal(e) {
      this.openAddDialog = false;
    },

    onSaveView() {
      // validation for view name to be more than 3 letters
      if (this.newViewName.length <= 3) {
        this.viewNameError = true;
        return;
      } else {
        this.viewNameError = false;
      }

      // validation for privacy to be set against a view
      if (this.viewPrivacy == "") {
        this.viewPrivacyError = true;
        return;
      } else {
        this.viewPrivacyError = false;
      }

      this.openAddDialog = false;
      // for new view
      if (this.newViewFlag) {
        if (this.newViewName) {
          if (
            this.newViewName === "Default View" ||
            this.newViewName === "Add a Tile View"
          ) {
            return null;
          } else {
            // removing extra content from selection
            if (this.viewPrivacy.includes("Private")) {
              this.viewPrivacy = "private";
            } else if (this.viewPrivacy.includes("Public")) {
              this.viewPrivacy = "public";
            }

            let obj = {
              detail: this.newViewName,
              privacy: this.viewPrivacy,
            };
            this.saveAsEventFromFeAgent(obj);
          }
        } else {
          return null;
        }
      } else {
        // edit call comes here
        sdtV2Service
          .editViewName(this.oldViewName, this.newViewName, this.moduleId)
          .then((response) => {
            let msg = response.data.description;
            this.fireResultEvent(2, msg);
            resetTilesAndViews();
            this.refresh();
            this.newViewName = "";
            this.newViewFlag = false;
            this.dialogButtonText = "Add";
            this.dialogTitle = "New View Tile";
          })
          .catch((error) => {
            throw error;
          });
      }
    },

    editView(e) {
      this.newViewFlag = false;
      this.oldViewName = e.detail;
      this.newViewName = e.detail;
      this.openAddDialog = true;
    },

    saveViewsOrder(e) {
      sdtV2Service
        .saveViewTileOrder(this.moduleId, e.detail)
        .then((response) => {
          if (response.description == "successfully  updated") {
            this.views.unshift(
              {
                name: "Add A View Tile",
                tileFlag: true,
                position: 0,
                privacy: "private",
              },
              {
                name: "Default View",
                tileFlag: true,
                position: 1,
                privacy: "private",
              }
            );
          }
        })
        .catch((error) => {
          throw error;
        });
    },

    onSelectedPrivacy(val) {
      this.viewPrivacy = val.value;
    },
  },

  beforeDestroy() {
    resetGlobalSearchValue_v2();
    resetGlobalFiltersArray_v2();
    window.removeEventListener("searchEvent", this.onSearchEvent);
    window.removeEventListener("sortEvent", this.onSort);
    window.removeEventListener("filterEvent", this.onFilterEvent);
    window.removeEventListener("selectViewEvent", this.onSelectChange);
    window.removeEventListener("deleteViewEvent", this.onDelButton);
    window.removeEventListener("saveViewEvent", this.onSaveClick);
    window.removeEventListener(
      "systemDefaultViewEvent",
      this.onSystemDefaultViewClick
    );
    window.removeEventListener("saveAsEvent", this.saveAsEventFromFeAgent);
    window.removeEventListener("defaultViewEvent", this.onDefButton);
    window.removeEventListener("viewDetailEvent", this.onclickView);
    window.removeEventListener("deleteBtnEvent", this.onclickDelete);
    window.removeEventListener("editButtonEvent", this.onclickEdit);
    window.removeEventListener("radioEvent", this.onRadioClick);
    window.removeEventListener("checkboxEvent", this.onClickCheckbox);
    window.removeEventListener("checkboxHeadEvent", this.onClickCheckboxHead);
    window.removeEventListener(
      "processCarrierBtnEvent",
      this.onProcessBtnClick
    );
    window.removeEventListener("tagBtnEvent", this.onTagBtnClick);
    window.removeEventListener("optionClickedEvent", this.onMoreOptionClick);
    window.removeEventListener("addNewViewEvent", this.addNewView);
    window.removeEventListener("setAsDefaultViewEvent", this.onDefButton);
    window.removeEventListener("editViewEvent", this.editView);
    window.removeEventListener("saveViewsOrder", this.saveViewsOrder);
  },

  watch: {
    count: function (newVal, oldVal) {
      if (this.filteredDataCount != 0) {
        getFilteredDataCount(
          this.filteredDataCount,
          getGlobalCurrentViewName_v2()
        );
        resetTilesAndViews();
        createViews_v2(this.moduleId, this.views, this.currentView);
      }
    },
    newViewFlag: function (nv, ov) {
      if (this.newViewFlag) {
        this.dialogButtonText = "Add";
      } else {
        this.dialogButtonText = "Edit";
        this.dialogTitle = "Edit View Tile";
      }
    },
    totalElements: function (nv, ov) {
      // Feature Request
      // If total elements (in any scenario) are less than the limit of records to be shown in table
      // then change limit to total number of records in pagination
      if (this.totalElements < this.pageEnd) {
        this.pageEnd = this.totalElements;
      }
    },
  },

  mounted() {
    let ress = getGlobalTableHeads_v2();
    window.addEventListener("searchEvent", this.onSearchEvent);
    window.addEventListener("sortEvent", this.onSort);
    window.addEventListener("filterEvent", this.onFilterEvent);
    window.addEventListener("selectViewEvent", this.onSelectChange);
    window.addEventListener("deleteViewEvent", this.onDelButton);
    window.addEventListener("saveViewEvent", this.onSaveClick);
    window.addEventListener(
      "systemDefaultViewEvent",
      this.onSystemDefaultViewClick
    );
    window.addEventListener("saveAsEvent", this.saveAsEventFromFeAgent);
    window.addEventListener("defaultViewEvent", this.onDefButton);
    window.addEventListener("viewDetailEvent", this.onclickView);
    window.addEventListener("deleteBtnEvent", this.onclickDelete);
    window.addEventListener("editButtonEvent", this.onclickEdit);
    window.addEventListener("radioEvent", this.onClickRadio);
    window.addEventListener("checkboxEvent", this.onClickCheckbox);
    window.addEventListener("checkboxHeadEvent", this.onClickCheckboxHead);
    window.addEventListener("processCarrierBtnEvent", this.onProcessBtnClick);
    window.addEventListener("tagBtnEvent", this.onTagBtnClick);
    window.addEventListener("optionClickedEvent", this.onMoreOptionClick);
    window.addEventListener("addNewViewEvent", this.addNewView);
    window.addEventListener("setAsDefaultViewEvent", this.onDefButton);
    window.addEventListener("editViewEvent", this.editView);
    window.addEventListener("saveViewsOrder", this.saveViewsOrder);

    this.newData = this.parentData;
    this.systemSettings = this.parentSystemSettings;
    this.defaultSystemView = this.parentDefaultSystemView;

    // setting actions/more choice
    window.actionsFlag = this.actionsButton;
    window.moreFlag = this.moreButton;

    sdtV2Service.setBaseUrlAndUsername(
      this.systemSettings.serviceURL,
      this.defaultSystemView.defaultTable.user,
      this.token
    );

    this.mapSystemSettings();

    sdtV2Service
      .getViews(this.defaultSystemView.defaultTable.pageName)
      .then((response) => {
        var viewData = response;

        this.defaultSystemView = viewData.data;
        if (this.defaultSystemView.defaultTable == null) {
          this.defaultSystemView.defaultTable =
            this.parentDefaultSystemView.defaultTable;
        }
        window.defaultView = this.defaultSystemView.defaultTable.viewName;

        this.defaultSystemView.viewNames.push(
          {
            name: "Default View",
            tileFlag: true,
            position: 1,
            privacy: "private",
          },
          {
            name: "Add A View Tile",
            tileFlag: true,
            position: 0,
            privacy: "private",
          }
        );

        // handling change of SDT's columns
        let heads = getGlobalTableHeads_v2();
        if (heads != null) {
          if (
            heads.length != this.defaultSystemView.defaultTable.columns.length
          ) {
            window.globalTableHeads_v2 = null;
            window.globalStaticColumns = [];
            setGlobalTableHeads_v2(this.defaultSystemView.defaultTable.columns);
            setGlobalStaticColumns(this.systemSettings.staticColumns);
          }
        }

        this.mapValues();
        this.initializeTable();

        // load filtered views if any
        let columns = this.defaultSystemView.defaultTable.columns;
        let flag = false;
        for (let index = 0; index < columns.length; index++) {
          if (columns[index].filters.length > 0 || columns[index].secondValue) {
            flag = true;
          }
        }
        if (flag && response.data.responseIdentifier != 2) {
          loadViewFilters(response.data);
        } else {
          this.fireResultEvent(1, getGlobalTableHeads_v2());
        }
      })
      .catch((error) => {
        throw error;
      });

    // setting table columns for multiple select
    this.setColumns();

    // setting length for select/unselect of columns
    this.prevLength =
      this.defaultSystemView.defaultTable.columns.length +
      this.parentSystemSettings.staticColumns.length;

    // FEATURE REQUEST
    // adding event handler to detect any clicks and close all opened dropdown instances
    let element = document.getElementById("module" + this.moduleId);
    element.addEventListener("click", function (event) {
      if (
        event.srcElement.id.includes("actionsBtn") ||
        event.srcElement.id.includes("moreBtn")
      ) {
        closePreviouslyOpenedDropdowns(event.srcElement.id);
      } else {
        closePreviouslyOpenedDropdowns("outsideClick");
      }
    });

    //setting theme color in search buttons and tiles
    // window.console.log(this.themeColor);

    // if(this.themeColor === 'alsharqi'){
    //     this.alsharqiFlag = true;
    //     setTileColor('#d03232');
    // }
    // else if(this.themeColor === 'qafila'){
    //     this.qafilaFlag = true;
    //     setTileColor('rgb(67, 123, 235)');
    // }
    // else if(this.themeColor !== 'qafila' && this.themeColor !== 'alsharqi' && this.themeColor){ //setting color passed
    //     this.colorFlag = true;
    //     setTileColor(this.themeColor);
    // }
    // else{  //default color
    //     this.colorFlag = true;
    //     window.globalTileColor = '#437beb';
    //     setTileColor(window.globalTileColor);
    // }
  },
};
</script>

<style lang="scss" scoped>
.error-class {
  border: 1px solid #d03232;
  box-shadow: none;
  outline: none;
}

* {
  box-sizing: border-box;
}

table {
  border-collapse: collapse;
  border-spacing: 0px;
  width: 100%;
  border-top: 1px solid #e1e1e1;
}

td,
th {
  padding: 5px 15px;
  text-align: left;
}

th {
  font-weight: bold;
}

img {
  cursor: pointer;
  /* height: 28px; */
}

/* Main Outer Div */
.outerDiv {
  max-width: 100%;
}

/* Right Icons Group */
.filter {
  margin-right: 5px;
  height: 27px;
}

.sh-dens-md {
  height: 30px;
}

.sh-dens-lg {
  margin-right: 5px;
}

.sh-dens-sm,
.sh-dens-md,
.sh-dens-lg {
  height: 27px;
}

.sh-dt-dv {
  -moz-box-shadow: 0px 0px -4px 4px #f0f0f0e8;
  -webkit-box-shadow: 0px 0px -4px 4px #f0f0f0e8;
  box-shadow: 0px 0px -4px 4px #f0f0f0e8;
}

.view-btn {
  background: white;
  border: none;
  height: 28px;
  padding: 0px;
  margin-right: 5px;
  cursor: pointer;
}
.view-txt {
  background: white;
  height: 28px;
  display: flex;
  margin-right: 5px;
}

.sh-icon {
  position: relative;
  text-align: right;
}

/* Settings Menu */
.table-heads-menu {
  z-index: 10;
  right: 0px;
  background: white;
  position: absolute;
  border: 1px solid rgb(218, 218, 218);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  width: 140px;
}

.sdt-filter {
  z-index: 10;
  right: 0px;
  background: white;
  position: absolute;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
}

.sh-views {
  width: 150px;
  position: absolute;
  z-index: 10;
  /*	top: 40px;*/
  margin-left: 0px;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.15);
}

.sh-setting-list {
  cursor: move;
  list-style-type: none;
  padding-left: 0px;
  text-align: left;
  margin: 0px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  overflow: scroll;
  height: 260px;
}

.sv-btn {
  text-align: center;
}

.sh-save-btn {
  background: rgb(67, 123, 235);
}
.sh-new-btn {
  background: orange;
}
.sh-del-btn {
  background: red;
}
.sh-def-btn {
  background: gray;
}
.sh-system-def-btn {
  background: #0582c5;
}

.sh-btn {
  color: white;
  border-style: unset;
  width: -webkit-fill-available;
  padding: 10px;
  cursor: pointer;
}

/* Table Head */
.tb-head {
  background-color: #dbdbdb8c;
  margin-top: 10px;
  box-shadow: 0px 20px 50px -22px var(--very-light-pink);
}

/* Table Head */
#tb-body {
  color: #787777;
}

/* Table Search */
.searchDiv {
  width: -webkit-fill-available;
  text-align: center;
}

.tableSearchbar {
  width: 60%;
  border: 1px solid #d9d4d4;
  padding: 7px;
  height: 30px;
}

.fa-search {
  position: relative;
  z-index: 999;
  bottom: 25px;
  right: 20px;
  color: #d9d4d4;
  font-size: larger;
}

::placeholder {
  color: #d9d4d4;
}

input:focus {
  outline-color: #d9d4d4;
}

/* Scrollbar */
/* ::-webkit-scrollbar-thumb {
        background: #d8d8d8;
        border-radius: 10px;
    }

    ::-webkit-scrollbar {
        width: 12px;
    }

    ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 0 white;
        border-radius: 10px;
    } */

::-webkit-scrollbar {
  width: 0px;
  background: transparent; /* make scrollbar transparent */
}
.normalBtnAlsharqi {
  background: #d03232;
  border: none;
  margin-left: 10px;
  height: 30px;
  color: white;
}
.normalBtnQafila {
  background: rgb(67, 123, 235);
  border: none;
  margin-left: 10px;
  height: 30px;
  color: white;
}
.normalBtn {
  background: #437beb; /* default */
  border: none;
  margin-left: 10px;
  height: 30px;
  color: white;
}
.sdt-tiles {
  display: flex;
  width: fit-content;
  overflow: hidden;
}
.tiles-arrow {
  position: relative;
  top: 80px;
}
.arrows {
  cursor: pointer;
  height: 28px;
}

.parent-tiles-div {
  direction: ltr;
  max-width: 90%;
  display: flex;
}

.parent-tiles-div::-webkit-scrollbar {
  height: 0px;
  background: transparent; /* make scrollbar transparent */
}

/************Pagination***********/
.pg-cont {
  float: right;
  display: flex;
  padding-top: 3px;
}
.sdt-pag {
  cursor: pointer;
  width: 20px;
  height: 20px;
  padding: 5px;
  margin-top: 6px;
}
.pg-bg:hover {
  background-color: var(--primary);
}
.pg-bg {
  background-color: var(--very-light-pink);
  height: fit-content;
}
.pg-list {
  min-height: 30px;
  font-size: 12px;
    font-family: "Roboto !important";
  padding-top: 8px;
  min-width: 70px;
  border: solid 1px #d8d8d8;
  text-align: center;
  border-left: none;
  border-right: none;
  width: fit-content;
  height: fit-content;
}
.dropdown {
  float: left;
  overflow: hidden;
}

.dropdown .dropbtn {
  font-size: 12px;
  border: none;
  border-radius: 20px;
  outline: none;
  color: black;
  padding: 10px 16px;
  background-color: #d8d8d8;
    font-family: "Roboto !important";
  margin: 0;
  font-weight: bold;
  cursor: pointer;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: white;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 11;
}

.dropdown-content a {
  float: none;
    font-family: "Roboto !important";
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  text-align: left;
  font-size: 12px;
  border-bottom: 1px solid #e1e1e1;
  cursor: pointer;
}

.dropdown-content a:hover {
  background-color: #f4f4f4;
  cursor: pointer;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.download-selected-arrow {
  width: 12px;
  height: 12px;
  margin-left: 10px;
}

.buttons-div {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  justify-content: space-around;
  align-items: end;
}
.saveViewBtn {
  font-size: 12px;
  border: none;
  border-radius: 20px;
  outline: none;
  color: black;
  padding: 10px 16px;
  background-color: #d8d8d8;
    font-family: "Roboto !important";
  margin: 0;
  font-weight: bold;
  margin-right: 20px;
  cursor: pointer;
}
.rightDiv {
  display: -webkit-inline-box;
  -webkit-box-align: end;
  justify-self: end;
  margin-right: 4%;
}
.newViewSaveBtn {
  font-size: 14px;
  border: none;
  outline: none;
  color: white;
  padding: 8px 16px;
  background-color: var(--brown-grey);
    font-family: "Roboto !important";
  margin: 0;
  font-weight: bold;
  margin-right: 5px;
  cursor: pointer;
  float: right;
  width: 135px;
}

.newViewSaveBtn:hover {
  background-color: var(--secondary);
}

.dialog-body {
  padding: 40px 30px;
}

.main-scroll-div::-webkit-scrollbar {
  height: 7px;
  width: 8px;
}

.main-scroll-div::-webkit-scrollbar-thumb {
  background-color: #979797;
  border-radius: 3.5px;
}

.main-scroll-div::-webkit-scrollbar-track {
  box-shadow: inset 0 0 0 white;
  border-radius: 3.5px;
  background-color: #e1e1e1;
}

.default-search-button {
  height: 30px !important;
  border: 1px solid #e1e1e1 !important;
    font-family: "Roboto !important";
  font-size: 12px;
  outline: none !important;
}
#scrollIt {
  overflow: hidden;
}
#control{
  display:none;
}
</style>
